import { render, staticRenderFns } from "./AsignaCup.vue?vue&type=template&id=28985769&scoped=true"
import script from "./AsignaCup.vue?vue&type=script&lang=js"
export * from "./AsignaCup.vue?vue&type=script&lang=js"
import style0 from "./AsignaCup.vue?vue&type=style&index=0&id=28985769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28985769",
  null
  
)

export default component.exports